import styles from "./styles.module.scss";
import Section from "../../components/Section";

import figma_icon from "../../graphics/figma_icon.svg";
import adobe_icon from "../../graphics/adobe_icon.svg";
import ai_icon from "../../graphics/ai_icon.svg";
import id_icon from "../../graphics/id_icon.svg";
import lrc_icon from "../../graphics/lrc_icon.svg";
import coral_draw_icon from "../../graphics/coral_draw_icon.svg";
import ae_icon from "../../graphics/ae_icon.svg";
import tilda_icon from "../../graphics/tilda_icon.svg";
import dsmax_icon from "../../graphics/3dsmax_icon.svg";
import js_icon from "../../graphics/js_icon.svg";
import html_icon from "../../graphics/html_icon.svg";
import css_icon from "../../graphics/css_icon.svg";

import bl_image from "../../images/bl.png";

const Skills = () => {
  return (
    <Section>
      <div className={styles.container}>
        <h2 className={styles.title}>НАВЫКИ</h2>
        <div className={styles.tools_container}>
          <h4 className={styles.subtitle}>Инструменты</h4>
          <div className={styles.tools}>
            <div className={styles.item}>
              <div>
                <div className={styles.item_title}>
                  <div>
                    <img src={figma_icon} alt="" />
                  </div>
                  <p>Figma</p>
                </div>
                <p className={styles.item_subtitle}>
                  Растровая/векторная графика
                </p>
              </div>
              <ul>
                <li>Компоненты/варианты</li>
                <li>Auto Layout</li>
                <li>Прототипирование</li>
                <li>Анимация</li>
              </ul>
            </div>

            <div className={styles.item}>
              <div>
                <div className={styles.item_title}>
                  <div>
                    <img src={adobe_icon} alt="" />
                  </div>
                  <p>Adobe Photoshop</p>
                </div>
                <p className={styles.item_subtitle}>Растровая графика</p>
              </div>
              <ul>
                <li>Коллажи</li>
                <li>Слой-маска</li>
                <li>Выделение различными спо-ми</li>
                <li>Ретуширование</li>
              </ul>
            </div>

            <div className={styles.item}>
              <div>
                <div className={styles.item_title}>
                  <div>
                    <img src={ai_icon} alt="" />
                  </div>
                  <p>Adobe Illustrator</p>
                </div>
                <p className={styles.item_subtitle}>Векторная графика</p>
              </div>
              <ul>
                <li>Слои</li>
                <li>Blend tool</li>
                <li>Работа с цветом и текстом</li>
                <li>Создание иллюстраций</li>
              </ul>
            </div>

            <div className={styles.icons_item}>
              <div className={styles.item_text}>
                <div>
                  <img src={id_icon} alt="" />
                </div>
                <p>Adobe InDesign</p>
              </div>
              <div className={styles.item_text}>
                <div>
                  <img src={lrc_icon} alt="" />
                </div>
                <p>Adobe Lightroom Classic</p>
              </div>
              <div className={styles.item_text}>
                <div>
                  <img src={coral_draw_icon} alt="" />
                </div>
                <p>CorelDRAW</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h4 className={styles.subtitle}>Дополнительные навыки:</h4>
          <div className={styles.skills}>
            <ul>
              <li>Работа с масками/плагинами</li>
              <li>Адаптивный дизайн</li>
              <li>Material, motion design</li>
              <li>User Flows, Wireframes</li>
            </ul>

            <ul>
              <li>Usability</li>
              <li>Работа в Figma Jam</li>
              <li>Разработка UI-китов</li>
              <li>Верстка сайтов</li>
            </ul>

            <div className={styles.icons}>
              <div className={styles.item}>
                <div>
                  <img src={ae_icon} alt="" />
                </div>
                <p>After Effects</p>
              </div>
              <div className={styles.item}>
                <div>
                  <img src={tilda_icon} alt="" />
                </div>
                <p>Tilda</p>
              </div>
              <div className={styles.item}>
                <div>
                  <img src={dsmax_icon} alt="" />
                </div>
                <p>3Ds Max</p>
              </div>
              <div className={styles.item}>
                <div>
                  <img src={js_icon} alt="" />
                </div>
                <p>JavaScript</p>
              </div>
              <div className={styles.item}>
                <div>
                  <img src={html_icon} alt="" />
                </div>
                <p>HTML</p>
              </div>
              <div className={styles.item}>
                <div>
                  <img src={css_icon} alt="" />
                </div>
                <p>CSS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Skills;
